// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3SpIs","select":"Header_select__16fyD","clinic":"Header_clinic__2l0Cz"};